import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

declare let gtag: (...args: any[]) => void;


@Injectable({ providedIn: 'root' })
export class AnalyticsInitializerService {

  private env = environment;

  private measurementId: string | null = null;

  constructor(private http: HttpClient) {}

  init(): Promise<void> {
    if (!environment.production) {
      console.warn('[Analytics] Não inicializado — ambiente de desenvolvimento');
      return Promise.resolve();
    }

    return this.http.get<{ measurementId: string }>(`${this.env.publicApiSocioUrl}v1/socio/google-analytics`)
      .toPromise()
      .then((googleAnalytic) => {
        if (!googleAnalytic?.measurementId) {
          console.warn('[Analytics] Measurement ID ausente');
          return;
        }
        this.measurementId = googleAnalytic.measurementId;
        return this.loadGAScript(googleAnalytic.measurementId).then(() => this.initializeGA(googleAnalytic.measurementId));
      })
      .catch(err => {
        console.error('[Analytics] Erro ao buscar ID:', err);
      });
  }

  private loadGAScript(id: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
      script.onload = () => resolve();
      script.onerror = () => reject();
      document.head.appendChild(script);
    });
  }

  private initializeGA(id: string) {
    window.dataLayer = window.dataLayer || [];
    (window as any).gtag = function () {
      window.dataLayer.push(arguments);
    };
    gtag('js', new Date());
    gtag('config', id, {
      send_page_view: false
    });

    console.info('[Analytics] Inicializado com ID:', id);
  }

  getMeasurementId(): string | null {
    return this.measurementId;
  }
}